import React from 'react';
import { cn } from '../../lib/utils';

export type StatusTone =
  | 'active'
  | 'suspicious'
  | 'recalled'
  | 'expired'
  | 'disabled'
  | 'anchored'
  | 'ai-flagged'
  | 'muted';

interface StatusBadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: StatusTone;
  size?: 'sm' | 'md';
  label?: string;
}

const toneClasses: Record<StatusTone, string> = {
  active: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  suspicious: 'bg-amber-100 text-amber-800 border-amber-200',
  recalled: 'bg-red-100 text-red-800 border-red-200',
  expired: 'bg-gray-100 text-gray-700 border-gray-200',
  disabled: 'bg-slate-100 text-slate-700 border-slate-200',
  anchored: 'bg-blue-100 text-blue-800 border-blue-200',
  'ai-flagged': 'bg-violet-100 text-violet-800 border-violet-200',
  muted: 'bg-gray-100 text-gray-700 border-gray-200',
};

const sizeClasses = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-xs',
};

export default function StatusBadge({
  tone = 'muted',
  size = 'md',
  label,
  className,
  children,
  ...props
}: StatusBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full border font-semibold uppercase tracking-wide',
        toneClasses[tone],
        sizeClasses[size],
        className
      )}
      {...props}
    >
      {label ?? children}
    </span>
  );
}

